/* eslint-disable no-irregular-whitespace */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchConfiguracoes, fetchRecuperarAcesso } from '../../api/endpoints';
import { getTotem } from '../../api/apiFactory';
import { selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao, fetchLogin, fetchLoginAnonimo } from '../../app/slices/loginSlice';
import { abrirModalAnonimo, fecharModalLogin, selectModal } from '../../app/slices/modalSlice';
import { definirSecretaria, selectSecretaria } from '../../app/slices/secretariasSlice';
import {
  ContainerJanela, Divisor, FormFooter, GridLoginInicial, Linha,
} from '../../styles/base';
import {
  cnpj, cpf, email, isCNPJ, tel,
} from '../../util/mascaras';
import Botao from '../Botao/Botao';
import { AbaContainer } from '../Botao/BotaoEstilo';
import Carregar from '../Carregar/Carregar';
import FormControl from '../FormControl/FormControl';
import {
  Aviso, JanelaLogin, LinkEmail, TituloModal,
} from './ModalLoginEstilo';
import GridBotao from '../GridBotao/GridBotao';

const defaultValues = {
  Usuario: '',
  Senha: '',
  Email: '',
  CpfCnpj: '',
  Telefone: '',
};

const ModalLogin = () => {
  const [telaInicial, setTelaInicial] = useState(true);
  const [recuperarSenha, setRecuperarSenha] = useState(false);
  const [recuperarCadastro, setRecuperarCadastro] = useState(false);
  const [emailLoginAtivo, setEmailLoginAtivo] = useState(true);
  const [emailRecuperarAtivo, setEmailRecuperarAtivo] = useState(true);
  const [carregando, setCarregando] = useState(false);
  const [cpfcnpjLoginAtivo, setCpfcnpjLoginAtivo] = useState(false);
  const [telefoneRecuperarAtivo, setTelefoneRecuperarAtivo] = useState(false);
  const [values, setValues] = useState(defaultValues);
  const [tipoCampoSenha, setTipoCampoSenha] = useState('senha');

  const dispatch = useDispatch();
  const alert = useAlert();
  const dadosModal = useSelector(selectModal);
  const dadosCidade = useSelector(selectCidade);
  const history = useHistory();

  const [verificarMudancaAnominoCidade, setVerificarMudancaAnominoCidade] = useState();

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  useEffect(() => {
    if (getTotem() === 'true') {
      document.getElementById('inputUsuarioEmail').focus();
      document.getElementById('inputUsuarioEmail').click();
    }

    fetchConfiguracoes().then((response) => setVerificarMudancaAnominoCidade(response));
  }, []);

  const recuperarAcessoSenhaEmail = async (event) => {
    event.preventDefault();
    setCarregando(true);
    const resposta = await fetchRecuperarAcesso(`e-${values.Email}`);

    if (resposta.Message === 'Nenhum registro foi encontrado.') {
      setCarregando(false);
      return alert.error('Nenhum registro foi encontrado.', { timeout: 5000 });
    }
    if (values.Email !== '') {
      setCarregando(false);
      alert.success('E-mail enviado com sucesso.', { timeout: 5000 });
    } else {
      alert.error('Por favor, preencha o campo "E-mail".', { timeout: 5000 });
      setCarregando(false);
    }
    setCarregando(false);
    return setValues(defaultValues);
  };

  const recuperarAcessoSenhaTelefone = async (event) => {
    event.preventDefault();
    setCarregando(true);
    const resposta = await fetchRecuperarAcesso(`t-${values.Telefone}`);

    if (resposta.Message === 'Nenhum registro foi encontrado.') {
      setCarregando(false);
      return alert.error('Nenhum registro foi encontrado.', { timeout: 5000 });
    }

    if (values.Telefone !== '') {
      setCarregando(false);
      alert.success('SMS enviado com sucesso.', { timeout: 5000 });
    } else {
      alert.error('Por favor, preencha o campo "Celular".', { timeout: 5000 });
      setCarregando(false);
    }
    setCarregando(false);
    return setValues(defaultValues);
  };

  const entrarAnonimo = async () => {
    if (dadosModal.origem === 'manifestacao') {
      await dispatch(await fetchLoginAnonimo({
        modulo: 'o',
      }));
    }
    if (dadosModal.origem === 'sic') {
      await dispatch(await fetchLoginAnonimo({
        modulo: 's',
      }));
    }
    if (dadosModal.origem === 'zeladoria') {
      await dispatch(await fetchLoginAnonimo({
        modulo: 'z',
      }));
    }

    if (dadosModal.origem === 'manifestacao' || dadosModal.origem === 'sic' || dadosModal.origem === 'zeladoria') {
      dispatch(definirSecretaria({
        idSecretaria: dadosModal.secretaria.idSecretaria,
        nomeSecretaria: dadosModal.secretaria.nomeSecretaria,
        corSecretaria: dadosModal.secretaria.corSecretaria,
      }));
    }

    if (dadosCidade.configuracoes.AcompanhamentoAnonimo === 'N') {
      dispatch(abrirModalAnonimo());
    }
    dispatch(fecharModalLogin());
  };

  const entrarCadastrado = async (event) => {
    event.preventDefault();
    setCarregando(true);

    if (!values.Usuario || !values.Senha) {
      dispatch(desfazerConexao());
      setCarregando(false);
      return alert.error('É necessário preencher todos os campos.', { timeout: 5000 });
    }

    const resposta = await dispatch(fetchLogin({
      username: values.Usuario,
      password: values.Senha,
    }));

    if (!values.Usuario) {
      dispatch(desfazerConexao());
      setCarregando(false);
      return alert.error('Acesso negado, por favor tente novamente.', { timeout: 5000 });
    }

    if (emailLoginAtivo && !values.Usuario.includes('@')) {
      dispatch(desfazerConexao());
      setCarregando(false);
      return alert.error('Acesso negado, por favor tente novamente.', { timeout: 5000 });
    }

    if (resposta.payload === 'Credencial errada.') {
      dispatch(desfazerConexao());
      setCarregando(false);
      return alert.error('Acesso negado, por favor tente novamente.', { timeout: 5000 });
    }

    setCarregando(false);

    if (dadosModal.origem === 'manifestacao' || dadosModal.origem === 'sic' || dadosModal.origem === 'zeladoria') {
      dispatch(definirSecretaria({
        idSecretaria: dadosModal.secretaria.idSecretaria,
        nomeSecretaria: dadosModal.secretaria.nomeSecretaria,
        corSecretaria: dadosModal.secretaria.corSecretaria,
      }));
    }

    // Se, no local onde o modal de login for invocado, eu enviar "redirect: true", eu irei fazer com que ao logar, redirecione para a url do módulo correspondente.
    // Inicialmente isso foi desenvolvido pensando no botão "passe livre estudantil" de Juiz de Fora que eu adicionei estaticamente na página inicial (SelecionarCidade).
    // Com o código abaixo, eu garantiria, que estando na tela inicial, ao logar em uma conta, já redirecionaria para o formulário de manifestação, com a secretaria já definida.
    if (dadosModal.secretaria && dadosModal.secretaria.redirect) {
      if (dadosModal.origem === 'manifestacao') {
        history.push('/ouvidoria');
      } else if (dadosModal.origem === 'sic') {
        history.push('/sic');
      } else if (dadosModal.origem === 'zeladoria') {
        history.push('/zeladoria');
      }
    }

    return dispatch(fecharModalLogin());
  };

  const manipularTipoCampoSenha = () => {
    if (tipoCampoSenha === 'senha') {
      setTipoCampoSenha('text');
    } else {
      setTipoCampoSenha('senha');
    }
  };

  if (telaInicial) {
    return (
      <ContainerJanela>
        <JanelaLogin className="controle-fundo controle-modal">
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao
              fechar
              onClick={() => dispatch(fecharModalLogin())}
            />
          </Linha>

          <TituloModal>Antes de registrar o seu pedido, escolha uma opção</TituloModal>

          <Divisor />

          <GridLoginInicial>
            <GridBotao
              selecaoInicial
              key="OuviCadastrardoria"
              label="Realizar um novo cadastro"
              to="/conta"
              onClick={() => dispatch(fecharModalLogin())}
              img="https://eouve.com.br/svg_icons/dark/cadastrar_line.svg"
              imgWidth={50}
              imgHeight={50}
              cor="#ffd03c"
            />
            <GridBotao
              selecaoInicial
              key="Entrar"
              label="Acessar com usuário e senha"
              img="https://eouve.com.br/svg_icons/dark/login_.svg"
              imgWidth={50}
              imgHeight={50}
              onClick={() => setTelaInicial(!telaInicial)}
              cor="#7db6ff"
            />

            {/* Eu precisei criar o objeto "verificarMudancaAnominoCidade" ao invés de usar "dadosCidade", pois eu preciso SEMPRE verificar se o sistema não alterou a propriedade de permitir ouvidoria ou sic em anônimo */}
            {/* "dadosCidade" é definido assim que a pessoa seleciona a cidade, e suas configurações só são ressetadas se o usuário "sair" da cidade e entrar novamente. Esse comportamento é falho pois caso o Felipe altere alguma configuração importante no sistema, enquanto alguém está logado, esta pessoa só receberá as alterações se sair e entrar denovo */}
            {/* A única diferença, que com "dadosCidade", eu tinha que acessar a propriedade "configuracoes" antes. Agora com "verificarMudancaAnominoCidade" eu posso acessar os atributos diretamente. */}
            {/* {((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'S' && dadosModal.origem === 'manifestacao') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoSic === 'S' && dadosModal.origem === 'sic')) && ( */}

            {/* 10534: Ocultando opção anônima para Secretaria de Passe Livre Estudantil em Juiz de Fora */}
            {(dadosModal && dadosModal.secretaria && dadosModal.secretaria.idSecretaria !== '10534') && (((verificarMudancaAnominoCidade && verificarMudancaAnominoCidade.OcultarAnonimoOuvidoria === 'S' && dadosModal.origem === 'manifestacao') || (verificarMudancaAnominoCidade && verificarMudancaAnominoCidade.OcultarAnonimoSic === 'S' && dadosModal.origem === 'sic') || (verificarMudancaAnominoCidade && verificarMudancaAnominoCidade.OcultarAnonimoZeladoria === 'S' && dadosModal.origem === 'zeladoria'))) && (
              <GridBotao
                selecaoInicial
                key="Anônimo"
                label="Continuar como Anônimo"
                onClick={entrarAnonimo}
                img="https://eouve.com.br/svg_icons/dark/entrar_anonimo.svg"
                imgWidth={50}
                imgHeight={50}
                cor="#dededd"
              />
            )}
          </GridLoginInicial>
        </JanelaLogin>
      </ContainerJanela>
    );
  }

  if (recuperarCadastro) {
    return (
      <ContainerJanela>
        <JanelaLogin>
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao
              fechar
              onClick={() => dispatch(fecharModalLogin())}
            />
          </Linha>

          <TituloModal>Solicitante - Sem acesso</TituloModal>

          <Divisor />

          <Aviso style={{ textAlign: 'center' }}>
            <b>Perdeu o acesso ou esqueceu o seu e-mail?</b>
            <br />
            <br />
            Entre em contato com o nosso suporte através do e-mail:
            {' '}
            <LinkEmail href="mailto: contato@webnets​.com.br">contato@webnets​.com.br</LinkEmail>
            {' '}
            informando o seu nome completo, CPF e a qual instituição está vinculado o cadastro.
            <br />
            <br />
            Retornaremos com as instruções para recuperar
            seu acesso em até 24 (vinte e quatro) horas úteis.
          </Aviso>

          <Divisor />

          <Divisor border size="pequeno" />

          <Botao
            label="Não tem cadastro? Cadastre-se"
            router
            to="/conta"
            onClick={() => dispatch(fecharModalLogin())}
          />

          <Divisor />

          <Botao
            label="Login"
            link
            onClick={() => {
              setRecuperarSenha(false);
              setRecuperarCadastro(false);
            }}
          />
        </JanelaLogin>
      </ContainerJanela>
    );
  }

  if (recuperarSenha) {
    return (
      <ContainerJanela>
        <JanelaLogin className="controle-fundo controle-modal">
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao
              fechar
              onClick={() => dispatch(fecharModalLogin())}
            />
          </Linha>

          <TituloModal>Solicitante - Esqueci minha senha</TituloModal>

          <Divisor />

          <form>
            {/* Não tem mais aba pois a opção de Celular será removida, logo ficará somente a do email */}
            {/* <AbaContainer aba style={{ justifyContent: 'space-around' }}>
              <div>
                <>
                  <Botao
                    aba
                    label="E-mail"
                    ativo={emailRecuperarAtivo}
                    onClick={() => {
                      setTelefoneRecuperarAtivo(false);
                      setEmailRecuperarAtivo(true);
                    }}
                  />
                  <Botao
                    aba
                    label="Celular"
                    ativo={telefoneRecuperarAtivo}
                    onClick={() => {
                      setTelefoneRecuperarAtivo(true);
                      setEmailRecuperarAtivo(false);
                    }}
                  />
                </>
              </div>
            </AbaContainer>

            <Divisor size="medio" />

            <Divisor size="medio" /> */}

            {emailRecuperarAtivo ? (
              <FormControl
                idCampo="inputEmail"
                value={values.Email && email(values.Email)}
                label="Informe o seu e-mail:"
                onChange={({ target }) => setVal('Email', target.value)}
              />
            ) : (
              <FormControl
                idCampo="inputTelefone"
                value={values.Telefone && tel(values.Telefone)}
                label="Informe o seu celular:"
                onChange={({ target }) => setVal('Telefone', target.value)}
              />
            )}

            <FormFooter style={{
              justifyContent: 'flex-start', alignItems: 'center', gap: 15, marginTop: 20,
            }}
            >
              {carregando !== true
                ? (
                  <Botao
                    label="Enviar"
                    type="submit"
                    onClick={emailRecuperarAtivo ? recuperarAcessoSenhaEmail : recuperarAcessoSenhaTelefone}
                  />
                )
                : (
                  <Carregar
                    style={{ flex: '0 0 93.02px', justifyContent: 'center' }}
                    login
                  />
                )}

              <Botao
                label="Voltar"
                onClick={() => {
                  setRecuperarSenha(false);
                }}
                style={{ backgroundColor: '#084999' }}
              />
            </FormFooter>

          </form>

          {/* <Botao
            link
            label="Não tem mais acesso ao seu e-mail? Clique aqui."
            onClick={() => setRecuperarCadastro(true)}
          /> */}
        </JanelaLogin>
      </ContainerJanela>
    );
  }

  return (
    <ContainerJanela>
      <JanelaLogin className="controle-fundo controle-modal">
        <Linha style={{ justifyContent: 'flex-end' }}>
          <Botao
            fechar
            onClick={() => dispatch(fecharModalLogin())}
          />
        </Linha>

        <TituloModal>Solicitante - Acessar com usuário e senha</TituloModal>

        <Divisor />

        <form>
          {dadosCidade && dadosCidade.data && dadosCidade.data.idCidade !== '1183' && (
            <>
              <AbaContainer aba style={{ justifyContent: 'space-around' }}>
                <div>
                  <>
                    <Botao
                      aba
                      label="E-mail"
                      ativo={emailLoginAtivo}
                      onClick={() => {
                        setCpfcnpjLoginAtivo(false);
                        setEmailLoginAtivo(true);
                        setValues({
                          ...values,
                          Usuario: '',
                        });
                      }}
                    />
                    <Botao
                      aba
                      label="CPF/CNPJ"
                      ativo={cpfcnpjLoginAtivo}
                      onClick={() => {
                        setCpfcnpjLoginAtivo(true);
                        setEmailLoginAtivo(false);
                        setValues({
                          ...values,
                          Usuario: '',
                        });
                      }}
                    />
                  </>
                </div>
              </AbaContainer>

              <Divisor size="medio" />

              <Divisor size="medio" />
            </>
          )}

          {emailLoginAtivo ? (
            <FormControl
              idCampo="inputUsuarioEmail"
              type={getTotem() === 'true' ? 'loginTotem' : ''}
              label="E-mail:"
              value={values.Usuario && email(values.Usuario)}
              onChange={({ target }) => setVal('Usuario', target.value)}

            />
          ) : (
            <>
              {values.Usuario && isCNPJ(values.Usuario)
                ? (
                  <FormControl
                    idCampo="inputCNPJ"
                    value={values.Usuario && cnpj(values.Usuario)}
                    label="CPF/CNPJ:"
                    onChange={({ target }) => setVal('Usuario', target.value)}
                    type={getTotem() === 'true' ? 'loginTotem' : ''}
                  />
                ) : (
                  <FormControl
                    idCampo="inputCPF"
                    value={values.Usuario && cpf(values.Usuario)}
                    label="CPF/CNPJ:"
                    onChange={({ target }) => setVal('Usuario', target.value)}
                    type={getTotem() === 'true' ? 'loginTotem' : ''}
                  />
                )}
            </>
          )}

          <div style={{ position: 'relative' }}>
            <FormControl
              idCampo="inputSenha"
              label="Senha:"
              value={values.Senha}
              type={tipoCampoSenha}
              onChange={({ target }) => setVal('Senha', target.value)}
            />

            <FormControl
              value={tipoCampoSenha}
              type="exibirSenha"
              altura="4"
              onClick={() => { manipularTipoCampoSenha(); }}
            />
          </div>

          <FormFooter style={{
            justifyContent: 'flex-start', alignItems: 'center', gap: 15, marginTop: 20,
          }}
          >
            {carregando !== true
              ? (
                <Botao
                  label="Entrar"
                  type="submit"
                  onClick={entrarCadastrado}
                />
              )
              : (
                <Carregar
                  style={{ flex: '0 0 91.36px', justifyContent: 'center' }}
                  login
                />
              )}

            <Botao
              label="Recuperar senha"
              onClick={() => {
                setRecuperarSenha(!recuperarSenha);
              }}
              style={{ backgroundColor: '#084999' }}
            />
          </FormFooter>
        </form>

      </JanelaLogin>
    </ContainerJanela>
  );
};

export default ModalLogin;
